import { render, staticRenderFns } from "./NewAd.vue?vue&type=template&id=180467fe&scoped=true&"
import script from "./NewAd.vue?vue&type=script&lang=js&"
export * from "./NewAd.vue?vue&type=script&lang=js&"
import style0 from "./NewAd.vue?vue&type=style&index=0&id=180467fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180467fe",
  null
  
)

export default component.exports